module.exports = __webpack_public_path__ + "static/media/java.a78324f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/java.png
// module id = 31
// module chunks = 0